import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { products } from '../data/mock';

const ProductsPage = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle hash navigation
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {/* Hero Banner */}
        <div className="relative h-[250px] bg-[#FFDA00]">
          <img
            src="https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/kkocva12_Home01.jpg"
            alt="Agricultural products"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white">Our Products</h1>
          </div>
        </div>

        {/* Products Grid */}
        <section className="py-12 px-4 bg-[#f5f5f0]">
          <div className="max-w-6xl mx-auto">
            <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
              ADA exports premium Australian agricultural products to destinations worldwide.
              Our commitment to quality ensures the highest standards from farm to market.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {products.map((product) => (
                <div
                  key={product.id}
                  id={product.slug}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[#FFDA00] mb-2">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      {product.description}
                    </p>
                    <ul className="space-y-1">
                      {product.features.map((feature, idx) => (
                        <li
                          key={idx}
                          className="text-sm text-gray-500 flex items-center gap-2"
                        >
                          <span className="w-1.5 h-1.5 bg-[#FFDA00] rounded-full"></span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ProductsPage;
